import React, { createElement } from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';
// --- Meta Pixel (PageView) ---
const PIXEL_ID = '2782582688765590';
(function initMetaPixel() {
  if (typeof window === 'undefined') return;
  const w = window as any;
  if (w.fbq) return;
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  s.parentNode?.insertBefore(t, s);
  w.fbq('init', PIXEL_ID);
  w.fbq('track', 'PageView');
})();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-145" />);
}